import { createElement, Fragment, HTMLAttributes, useMemo } from "react";
import { renderer } from "@atlas/renderer";
import styles from "../styles/content.module.css";
import createFilestackImageURI from "@atlas/tool/box/file/createFilestackImageURI";

const IMG_RESIZE_WIDTH = 1300;

export default function Content({
  nodes,
  baseUrl,
  defaultImageAlt,
  ...divProps
}: ContentProps) {
  const normalizedNodes = useMemo(
    () =>
      nodes.map(function ensureImageAltAndLoadedWidth(node: any): any {
        if (node.type === "image") {
          const nextAlt = node.alt ?? defaultImageAlt;

          // if image is unnecessarily large, use a shrank version to improve load speed
          const nextSrc =
            node?.handle &&
            node?.originalWidth &&
            node?.originalWidth > IMG_RESIZE_WIDTH
              ? createFilestackImageURI(
                  { handle: node.handle },
                  {
                    resize: { width: IMG_RESIZE_WIDTH, fit: "max" },
                  }
                )
              : node.src;

          return { ...node, alt: nextAlt, src: nextSrc };
        }

        return node;
      }),
    [nodes, defaultImageAlt]
  );

  return (
    <div {...divProps} className={styles.container}>
      {renderer(createElement, Fragment, normalizedNodes, { baseUrl: baseUrl })}
    </div>
  );
}

interface ContentProps extends HTMLAttributes<HTMLDivElement> {
  nodes: Array<any>;
  defaultImageAlt: string;
  baseUrl: string;
}
